import React, { useRef, useEffect } from "react";

const RegularLoader = ({ size = 80, className = "" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    let animationFrameId;

    const dpr = window.devicePixelRatio || 1;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;

    ctx.setTransform(1, 0, 0, 1, 0, 0); // reset transform
    ctx.scale(dpr, dpr);

    const centerX = size / 2;
    const centerY = size / 2;
    const radius = size * 0.4;

    let start = null;

    const drawShield = () => {
      ctx.save();
      ctx.translate(centerX, centerY + size * 0.03);
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#2563eb"; // blue-600
      ctx.fillStyle = "#eff6ff"; // blue-50

      // Shield shape
      ctx.beginPath();
      ctx.moveTo(0, -size * 0.18);
      ctx.lineTo(-size * 0.16, -size * 0.05);
      ctx.lineTo(-size * 0.12, size * 0.12);
      ctx.quadraticCurveTo(0, size * 0.22, size * 0.12, size * 0.12);
      ctx.lineTo(size * 0.16, -size * 0.05);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      // Check mark
      ctx.beginPath();
      ctx.strokeStyle = "#16a34a"; // green-600
      ctx.lineWidth = 2.2;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";

      ctx.moveTo(-size * 0.07, 0);
      ctx.lineTo(-size * 0.01, size * 0.06);
      ctx.lineTo(size * 0.08, -size * 0.02);

      ctx.stroke();
      ctx.restore();
    };

    const draw = (timestamp) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;

      const angle = (progress / 1000) * Math.PI * 2 * 0.7; // speed

      ctx.clearRect(0, 0, size, size);

      // Background circle
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.strokeStyle = "#e5e7eb"; // gray-200
      ctx.lineWidth = 4;
      ctx.stroke();

      // Rotating arc
      ctx.beginPath();
      const arcLength = Math.PI * 1.1;
      ctx.arc(centerX, centerY, radius, angle, angle + arcLength);
      ctx.strokeStyle = "#2563eb"; // blue-600
      ctx.lineWidth = 4;
      ctx.lineCap = "round";
      ctx.stroke();

      // Shield icon
      drawShield();

      animationFrameId = requestAnimationFrame(draw);
    };

    animationFrameId = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [size]);

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default RegularLoader;


// import { ShieldCheck } from "lucide-react";

// const WarrantyLoader = () => {
//   return (
//     <div className="flex flex-col items-center justify-start pt-32"> 

//       {/* Animated Shield Loader */}
//       <div className="relative flex items-center justify-center">

//         {/* Glowing Ring */}
//         <div className="absolute w-20 h-20 rounded-full border-4 border-blue-400/40 animate-ping"></div>

//         {/* Rotating Border */}
//         <div className="absolute w-20 h-20 rounded-full border-4 border-blue-500 animate-spin-slow"></div>

//         {/* Shield Icon */}
//         <ShieldCheck
//           size={48}
//           className="text-blue-600 drop-shadow-[0_0_10px_rgba(0,102,255,0.5)] animate-bounce pt-4"
//         />
//       </div>

//       <p className="text-sm text-gray-600 font-medium pt-5 text-center">
//        Loading.....
//       </p>
//     </div>
//   );
// };

// export default WarrantyLoader;
